import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  forwardRef,
  NgZone,
  Renderer2,
} from '@angular/core';
import { WIZ_DRAGGABLE_COMPONENT } from '../../../directives/behavior/drag-drop/wiz-drag-drop.model';
import { WizBaseCollector } from '../../core/wiz-base-collector';
import { BASE_COMPONENT, WizBaseComponent } from './../../core/wiz-base-component';
import { IWIZ_COMPONENT} from '../../../interfaces/iwiz-component';
import { WDSChanges } from '@wizeoo/akm-core-lib';

@Component({
  selector: 'wiz-list',
  templateUrl: './wiz-list.html',
  styleUrls: ['./wiz-list.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    { provide: BASE_COMPONENT, useExisting: forwardRef(() => WizList) },
    { provide: WizBaseComponent, useExisting: forwardRef(() => WizList) },
    { provide: IWIZ_COMPONENT, useExisting: forwardRef(() => WizList) },
    {
      provide: WIZ_DRAGGABLE_COMPONENT,
      useExisting: forwardRef(() => WizList),
    },
  ],
})
export class WizList extends WizBaseCollector implements AfterViewInit {
  /**
   * Les données affichées dans la liste. Les données sont fournies par la datasource liées
   *
   *  @private
   */
  _data: any[];

  // Ajout d'un padding-bottom si le container de la liste affiche un scroll, pour permettre de drag/drop à la fin de la liste.
  get addBottomPaddingToViewport(): boolean {
    return this.wizVirtualScroll['_totalContentSize'] > this.wizVirtualScroll.getViewportSize();
  }

  /** Constructor with translation engine
   * @param cdref: ChangeDetectorRef
   * @param elementRef: the dom of the component
   * @param renderer: object that will allow the interaction between the component and the DOM
   */
  constructor(cdref: ChangeDetectorRef, elementRef: ElementRef, renderer: Renderer2, public ngZone: NgZone) {
    super(cdref, elementRef, renderer, ngZone);
  }

  // ####
  // ####
  // #### mécanique interne ####
  // ####
  // ####
  onProviderChanges(changes: WDSChanges) {
    if (changes && (changes.type !== 'selectionChanged' || !this._data)) {
      this._data = [...this.wizDataProvider.getWorkedSource()];
    }

    super.onProviderChanges(changes);
  }

  /** à overrider pour alimentation de la collection de travail */
  public _isSelected(item: any): boolean {
    if (this.wizDataProvider) {
      return this.wizDataProvider.isSelected(item);
    }
    return false;
  }

  /**
   * sélection d'un item, par clic / par space
   */
  public onRowSelected(selectedItem: number) {
    this.doSelect(this.wizDataProvider.getItem(selectedItem));
  }

  /**
   * double clic sur un item
   * @param idx, index de l'item
   */
  public onDoubleClick(idx: number): void {
    // seulement si différent de none
    if (this.wizDataProvider.selectionMode !== 'none') {
      const target = this.wizDataProvider.getItem(idx); // collecte de l'item
      super.emitDoubleClick(target);
    }
  }
}
